import { render } from "./DeletePopup.vue?vue&type=template&id=44a1e482&ts=true"
import script from "./DeletePopup.vue?vue&type=script&lang=ts"
export * from "./DeletePopup.vue?vue&type=script&lang=ts"

import "./DeletePopup.vue?vue&type=style&index=0&id=44a1e482&lang=scss"

import exportComponent from "/builds/likeacoffee.com/time-assistantv3-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__